import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            rateStep: localStorage.getItem("SAS_RATE_STEP"),
            rateId: localStorage.getItem("SAS_RATE_ID"),
            details: localStorage.getItem("SAS_RATE_DETAILS"),
            edu: localStorage.getItem("SAS_RATE_EDU"),
            EXP: localStorage.getItem("SAS_RATE_EXP"),
        };
    },
    mutations,
    actions,
    getters,
};